import { Component } from 'js-component-framework';

/**
 * Component for instantiating Site Search Facets
 */
export default class SearchFacets extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Elements
    this.form = document.getElementById('prb-search-form');

    // Immediately exit if form does not exist on page
    if (! this.form) {
      return;
    }

    // Facet clicked.
    this.triggerfacetClicked();

    // Update the orders.
    this.updateInputOnClick(
      'prb-search-orderby-desc-date',
      'order',
      'DESC'
    );
    this.updateInputOnClick(
      'prb-search-orderby-asc-date',
      'order',
      'ASC'
    );
    this.updateInputOnClick(
      'prb-search-orderby-relevance',
      'orderby',
      'post__in'
    );

    this.setToggleTrigger();
  }

  /**
   * Set toggle trigger to show/hide facets
   */
  setToggleTrigger() {
    this.children.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggle();
    });
  }

  /**
   * Set toggle to show/hide facets
   */
  toggle() {
    if (this.children.facets[0]) {
      this.children.facets[0].classList.toggle(this.options.closedClass);
    }
  }

  /**
   * Re-submit the form when a new facet is selected.
   */
  triggerfacetClicked() {
    const form = this.form;
    Array.prototype.forEach.call(this.children.facets, (facet) => {
      facet.addEventListener('click', () => {
        form.submit();
      }, false);
    });
  }

  /**
   * Update an input field with a new value on button click.
   *
   * @param  {string} el    The button selector.
   * @param  {string} field The input field selector.
   * @param  {string} value The new value.
   */
  updateInputOnClick(el, field, value) {
    const orderEl = document.getElementById(el);
    const form = this.form;
    if (orderEl) {
      orderEl.addEventListener('click', (event) => {
        event.preventDefault();

        // Get the order input field.
        form.querySelectorAll(`input[name="${field}"]`)[0].value = value;

        if ('order' === field) {
          form.querySelectorAll('input[name="orderby"]')[0].value = 'date';
        }

        // Re-submit the form.
        form.submit();
      }, false);
    }
  }
}



// WEBPACK FOOTER //
// ./client/js/components/SearchFacets/SearchFacets.js